import React, { useContext } from 'react'
import Box from '../../box'
import TextField from '../../textfield'
import DescriptionStepContext from './description_step_context'
import Editor from '../../quill_editor'
import Typography from '../../typography'
import { Divider } from '@mui/material'

const DescriptionStep: React.FC = () => {
  const {
    data: formData,
    setStepData: setStepFormData
  } = useContext(DescriptionStepContext)

  const { title, description, price, maxOccupancy, minimumSessionLength } = formData

  const onInputChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const { name, value } = e.target
    setStepFormData({
      ...formData as any,
      [name]: value
    })
  }

  const onDescriptionChange = (value: string): void => {
    setStepFormData({
      ...formData,
      description: value
    })
  }

  return (
    <Box>
      <TextField
        fullWidth
        name = 'title'
        value = {title}
        onChange = {onInputChange}
        label="Title"
        variant="outlined"
        gutterBottom
      />
      <Box display={'flex'} gap={2}>
        <TextField
          name = 'price'
          value = {price}
          onChange = {onInputChange}
          type='number'
          fullWidth
          label="Hourly Rate"
          variant="outlined"
          gutterBottom
          />
        <TextField
          name = 'maxOccupancy'
          value = {maxOccupancy}
          onChange = {onInputChange}
          type='number'
          fullWidth
          label="Max Occupancy"
          variant="outlined"
          gutterBottom
        />
        <TextField
          name = 'minimumSessionLength'
          value = {minimumSessionLength}
          onChange = {onInputChange}
          type='number'
          fullWidth
          label="Minimum Booking Time (minutes)"
          variant="outlined"
          />
      </Box>
      <Divider sx={{ mt: 2, mb: 2 }} />
      <Typography mt={2} mb={2} variant='h6' gutterBottom>
        Studio Description
      </Typography>
      <Editor
        toolbar={{
          disableH1: true
        }}
        value = {description}
        onChange = {onDescriptionChange}
      />
    </Box>
  )
}

export default DescriptionStep
